export const ANNOTATION = 'annotation'
export const LYRIC_EXPAND = 'lyricExpand'
export const DOTS = 'dots'
export const DOUBLESPEAKER = 'doublespeaker'
export const CAROUSEL = 'carousel'
export const ACTIVATED_VERSE = 'activatedVerse'
export const ACCESS = 'access'
export const STANZA_TAB = 'stanzaTab'
export const WORMHOLES = 'wormholes'
export const WIKI = 'wiki'
export const SLIDER = 'slider'
export const SCORE = 'score'
export const FILMSTRIP = 'filmstrip'
export const TIPS = 'tips'
export const AUTOSCROLL = 'autoscroll'
export const NAV = 'nav'
export const ABOUT = 'about'
export const OVERVIEW = 'overview'
